var render = function render(){
  var _vm$form$template$0$c, _vm$form$template$0$c2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.$freeParticulier() || _vm.$hasAtLeastOneGuest() ? _c('div', {
    on: {
      "keydown": function ($event) {
        return _vm.progressbar.userKeyDown();
      },
      "keyup": function ($event) {
        return _vm.progressbar.userKeyUp();
      },
      "click": _vm.calculate_progress
    }
  }, [_c('create-evaluation-popup', {
    attrs: {
      "is-opened": _vm.show_add_evaluation,
      "date-debut": _vm.form.date_debut_evaluation,
      "date-fin": _vm.form.date_fin_evaluation
    },
    on: {
      "close": function ($event) {
        _vm.show_add_evaluation = false;
      },
      "changeDateDebut": function (newValue) {
        if (_vm.form.date_fin_evaluation == '' || _vm.$verifyDates({
          debut: newValue,
          fin: _vm.form.date_fin_evaluation
        })) {
          _vm.form.date_debut_evaluation = newValue;
        } else {
          _vm.badDates();
          _vm.form.date_debut_evaluation = '';
        }
      },
      "changeDateFin": function (newValue) {
        if (_vm.form.date_debut_evaluation == '' || _vm.$verifyDates({
          debut: _vm.form.date_debut_evaluation,
          fin: newValue
        })) {
          _vm.form.date_fin_evaluation = newValue;
        } else {
          _vm.badDates();
          _vm.form.date_fin_evaluation = '';
        }
      },
      "createEvaluation": _vm.create_evaluation
    }
  }), _vm._v(" "), _c('close-evaluation-popup', {
    attrs: {
      "is-opened": _vm.confirmCloseEvaluation > -1,
      "is-step-one": _vm.confirmCloseEvaluation == 0,
      "is-step-two": _vm.confirmCloseEvaluation == 1,
      "today": _vm.today
    },
    on: {
      "close": function ($event) {
        _vm.confirmCloseEvaluation = -1;
      },
      "closeEval": _vm.close_eval
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "my-15 w-full"
  }, [_vm._v("\n    " + _vm._s(!_vm.$freeParticulier() && !_vm.$isGuest() ? _vm.infosPage.libelle_template : _vm.infosPage.libelle_page) + "\n  ")]), _vm._v(" "), _vm.form.date_debut_evaluation == '' || _vm.form.date_fin_evaluation == '' || _vm.form.id_ref == 0 || _vm.form.template == {} || _vm.$freeParticulier() && !_vm.$hasAtLeastOneGuest() ? _c('div', [_vm.role === _vm.constants.ROLE_BENEFICIAIRE ? _c('div', {
    staticClass: "flex justify-center mb-10"
  }, [_c('change-structure-input', {
    staticClass: "w-max"
  })], 1) : _vm._e(), _vm._v(" "), _vm.$can(_vm.infosPage.name_page + '_edit', _vm.infosPass.id_pass) && _vm.role !== _vm.constants.ROLE_BENEFICIAIRE && !_vm.$freeParticulier() ? _c('div', [_c('div', {
    staticClass: "flex justify-center w-full"
  }, [_c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-indigo-600",
      "bg-color-square": "bg-indigo-600",
      "icon-color": "text-white",
      "libelle": "AJOUTER UNE ÉVALUATION",
      "uppercase": true,
      "icon": "plus-circle",
      "type-shadow": "shadow-indigo"
    },
    on: {
      "clickAction": function ($event) {
        _vm.show_add_evaluation = true;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center w-full"
  }, [_c('illustration', {
    staticClass: "mt-15",
    attrs: {
      "name": "evaluation"
    }
  })], 1)]) : _vm.$freeParticulier() ? _c('div', [_c('div', {
    staticClass: "text-indigo-600 text-lg text-center"
  }, [_vm._v("\n        Votre invité n'a pas ouvert d'évaluation, il n'est donc pas possible\n        de s'évaluer actuellement.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center w-full"
  }, [_c('illustration', {
    staticClass: "mt-15",
    attrs: {
      "name": "notAllowed"
    }
  })], 1)]) : _c('div', [_c('div', {
    staticClass: "text-indigo-600 text-lg text-center"
  }, [_vm._v("\n        Il n’y a pas d’évaluation en cours\n        "), _vm.listEvaluations.length > 0 ? _c('span', [_vm._v("\n          , vous pouvez consulter\n          "), _c('br'), _vm._v("\n          vos évaluations précédentes dans l’historique ci-dessous\n        ")]) : _vm._e(), _vm._v("\n        .\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center w-full"
  }, [_c('illustration', {
    staticClass: "mt-15",
    attrs: {
      "name": "notAllowed"
    }
  })], 1)])]) : _c('div', [_vm.role === _vm.constants.ROLE_BENEFICIAIRE ? _c('div', {
    staticClass: "flex justify-center mb-10"
  }, [_c('change-structure-input', {
    staticClass: "w-max"
  })], 1) : _vm._e(), _vm._v(" "), _vm.compareCarto ? _c('PopupCompareCarto', {
    attrs: {
      "compare-carto": _vm.compareCarto,
      "carto-to-compare": _vm.cartoToCompare,
      "history-to-display": _vm.historyToDisplay,
      "competences-cles": {},
      "history-competences-cles": [],
      "competences-informatique": {},
      "history-competences-informatique": [],
      "competences-linguistique": {},
      "history-competences-linguistique": [],
      "competences-socio-pro": _vm.competencesSocioPro,
      "history-competences-socio-pro": _vm.historiesToCompare
    },
    on: {
      "close": _vm.closeCompare,
      "changeCompare": function (index) {
        _vm.changeCompare(index);
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm.role !== _vm.constants.ROLE_BENEFICIAIRE && !_vm.user.is_particulier && _vm.$can(_vm.infosPage.name_page + '_edit', _vm.infosPass.id_pass) ? _c('div', {
    staticClass: "w-full mb-10 2xl:mb-20 flex justify-center"
  }, [_c('list-action-buttons', {
    attrs: {
      "today": _vm.today,
      "libelle-template": _vm.infosPage.libelle_template,
      "can-compare-cartography": _vm.canCompare && _vm.listEvaluations.length > 0,
      "can-compare-but-not-enough-evaluation": _vm.canCompare && _vm.listEvaluations.length === 0
    },
    on: {
      "confirmCloseEvaluation": function ($event) {
        _vm.confirmCloseEvaluation = 0;
      },
      "displayCompareCarto": function ($event) {
        return _vm.displayCompareCarto('sociopro/' + _vm.infosPage.name_page);
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), ((_vm$form$template$0$c = _vm.form.template[0].criterions) === null || _vm$form$template$0$c === void 0 ? void 0 : _vm$form$template$0$c.length) > 1 && ((_vm$form$template$0$c2 = _vm.form.template[0].criterions) === null || _vm$form$template$0$c2 === void 0 ? void 0 : _vm$form$template$0$c2.length) < 6 ? _c('CheckboxIndigo', {
    staticClass: "ml-10 mb-4",
    attrs: {
      "libelle": "Mode simplifié",
      "value": _vm.jauge
    },
    on: {
      "input": _vm.toggleJaugeDisplay
    }
  }) : _vm._e(), _vm._v(" "), !_vm.$isMobile() ? _c('div', [_c('div', {
    staticClass: "text-lg text-gray-600 grid grid-cols-12 gap-x-4 content-start h-16 2xl:h-24"
  }, [_c('div', {
    staticClass: "mx-10 col-span-5"
  }, [_vm._v("Intitulé")]), _vm._v(" "), _c('div', {
    staticClass: "col-span-2 text-center"
  }, [_vm._v("Auto-évaluation")]), _vm._v(" "), _c('div', {
    staticClass: "col-span-2 text-center",
    class: {
      hidden: _vm.infosPass.id_pass == _vm.user.id
    },
    on: {
      "mouseover": function ($event) {
        _vm.isDisplayLastEvalTooltip = true;
      },
      "mouseleave": function ($event) {
        _vm.isDisplayLastEvalTooltip = false;
      }
    }
  }, [_c('info-bulle-hover', {
    attrs: {
      "is-display-tooltip": _vm.isDisplayLastEvalTooltip,
      "name": "lastEvalTooltip",
      "libelle": "Dernière évaluation du référent"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Dernière éval.ref")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-span-2 text-center"
  }, [_c('span', {
    class: {
      hidden: _vm.infosPass.id_pass == _vm.user.id
    },
    on: {
      "mouseover": function ($event) {
        _vm.isDisplayEvalRefTooltip = true;
      },
      "mouseleave": function ($event) {
        _vm.isDisplayEvalRefTooltip = false;
      }
    }
  }, [_c('info-bulle-hover', {
    attrs: {
      "is-display-tooltip": _vm.isDisplayEvalRefTooltip,
      "name": "evalRefTooltip",
      "libelle": "Nouvelle évaluation du référent"
    }
  }), _vm._v("\n            Nouvelle éval.ref\n          ")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "mr-10 col-span-1 text-center",
    class: {
      hidden: _vm.infosPass.id_pass == _vm.user.id
    },
    on: {
      "mouseover": function ($event) {
        _vm.isDisplayCommentairesTooltip = true;
      },
      "mouseleave": function ($event) {
        _vm.isDisplayCommentairesTooltip = false;
      }
    }
  }, [_c('info-bulle-hover', {
    attrs: {
      "is-display-tooltip": _vm.isDisplayCommentairesTooltip,
      "name": "commentairesTooltip",
      "libelle": "Commentaires"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Comm.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-start-6 col-span-2 flex items-center justify-center",
    class: {
      hidden: _vm.infosPass.id_pass == _vm.user.id,
      'cursor-help': !_vm.$can('compsocio_auto_eval_read', _vm.infosPass.id_pass),
      'cursor-pointer': _vm.$can('compsocio_auto_eval_read', _vm.infosPass.id_pass)
    },
    attrs: {
      "title": _vm.$can('compsocio_auto_eval_read', _vm.infosPass.id_pass) ? null : 'Permission manquante'
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        _vm.$can('compsocio_auto_eval_read', _vm.infosPass.id_pass) ? _vm.hide('autoEval') : null;
      }
    }
  }, [_c('icon', {
    staticClass: "h-3 w-4 text-pink-600",
    attrs: {
      "name": _vm.autoHidden ? 'eye-off' : 'eye'
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "ml-3 text-sm select-none"
  }, [_vm._v(_vm._s(_vm.autoHidden ? 'Afficher' : 'Masquer'))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-span-2 flex items-center justify-center cursor-pointer",
    class: {
      hidden: _vm.infosPass.id_pass == _vm.user.id
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.hide('lastEval');
      }
    }
  }, [_c('icon', {
    staticClass: "h-3 w-4 text-pink-600",
    attrs: {
      "name": _vm.lastHidden ? 'eye-off' : 'eye'
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "ml-3 text-sm select-none"
  }, [_vm._v(_vm._s(_vm.lastHidden ? 'Afficher' : 'Masquer'))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-span-2"
  })]), _vm._v(" "), _vm._l(this.form.template[1].criterions, function (intitule, index) {
    return _c('div', {
      key: index,
      staticClass: "even:bg-gray-200 even:bg-opacity-50 grid grid-cols-12 gap-x-4 content-center py-5 xl:min-h-24 2xl:min-h-32 items-center"
    }, [_c('div', {
      staticClass: "col-span-1 mx-auto pl-4 w-min-content w-min justify-center flex flex-col"
    }, [_c('info-bulle', {
      attrs: {
        "libelle": intitule.libelle,
        "name": intitule.libelle
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-span-1 flex"
    }, [_c('TextToSpeech', {
      attrs: {
        "speak": intitule.description,
        "withBars": false
      }
    })], 1), _vm._v(" "), _c('label', {
      staticClass: "col-span-3 my-5 text-base",
      attrs: {
        "for": "comprehension_ecrite"
      }
    }, [_vm._v("\n          " + _vm._s(intitule.description) + "\n        ")]), _vm._v(" "), !_vm.autoHidden && _vm.jauge ? _c('AnswerJauge', {
      staticClass: "md:col-span-2",
      attrs: {
        "disabled": false,
        "criteria": _vm.form.template[0].criterions,
        "reduced": false,
        "selected": _vm.form.items[index].autoEval
      },
      on: {
        "select": function (answerIndex) {
          return _vm.select(index, 'autoEval', answerIndex, _vm.form.template[0].criterions);
        }
      }
    }) : _vm._e(), _vm._v(" "), !_vm.autoHidden && !_vm.jauge ? _c('input-select', {
      staticClass: "md:col-span-2 lg:justify-self-center",
      attrs: {
        "name": index + 'auto_eval',
        "libelle": "",
        "disabled": _vm.autoEvalDisabled,
        "datas": _vm.form.template[0].criterions,
        "value": _vm.form.items[index].autoEval
      },
      on: {
        "input": function (newValue) {
          return _vm.select(index, 'autoEval', newValue, _vm.form.template[0].criterions);
        }
      }
    }) : _vm._e(), _vm._v(" "), _vm.autoHidden ? _c('div', {
      staticClass: "col-span-2 justify-self-center"
    }) : _vm._e(), _vm._v(" "), !_vm.lastHidden ? _c('input-text', {
      staticClass: "md:col-span-2 justify-self-center",
      class: {
        hidden: _vm.infosPass.id_pass == _vm.user.id
      },
      attrs: {
        "name": index + 'derniere_eval',
        "libelle": "",
        "disabled": true,
        "value": _vm.lastValue(intitule)
      }
    }) : _vm._e(), _vm._v(" "), _vm.infosPass.id_pass == _vm.user.id && !_vm.jauge ? _c('AnswerJauge', {
      attrs: {
        "disabled": false,
        "criteria": _vm.form.template[0].criterions,
        "reduced": false,
        "selected": _vm.form.items[index].autoEval
      },
      on: {
        "select": function (answerIndex) {
          return _vm.select(index, 'autoEval', answerIndex, _vm.form.template[0].criterions);
        }
      }
    }) : _vm._e(), _vm._v(" "), _vm.lastHidden ? _c('div', {
      staticClass: "col-span-2 justify-self-center"
    }) : _vm._e(), _vm._v(" "), _c('input-select', {
      staticClass: "md:col-span-2 justify-self-center",
      class: {
        hidden: _vm.infosPass.id_pass == _vm.user.id
      },
      attrs: {
        "name": index + 'nouvelle_eval',
        "libelle": "",
        "necessary": true,
        "datas": _vm.form.template[0].criterions,
        "value": _vm.form.items.filter(function (item) {
          return item.name && item.name === intitule.libelle || item.description === intitule.description;
        })[0].refEval,
        "disabled": _vm.infosPass.id_pass == _vm.user.id ? true : false
      },
      on: {
        "input": function (newValue) {
          _vm.$set(_vm.form.items[index], 'refEval', newValue);
        }
      }
    }), _vm._v(" "), _c('icon-comment', {
      staticClass: "cursor-pointer md:col-span-1 lg:place-self-center mr-10",
      class: {
        hidden: _vm.infosPass.id_pass == _vm.user.id
      },
      attrs: {
        "name": 'comment-' + index,
        "value": _vm.form.items[index].comment
      },
      on: {
        "input": function (newValue) {
          _vm.$set(_vm.form.items[index], 'comment', newValue);
        }
      }
    })], 1);
  })], 2) : _c('div', _vm._l(_vm.form.template[1].criterions, function (intitule, index) {
    return _c('div', {
      key: index,
      staticClass: "odd:bg-indigo-100 odd:bg-opacity-50"
    }, [_c('div', {
      staticClass: "h-auto py-5 min-h-16 lg:min-h-24 2xl:min-h-32 cursor-default hover:bg-indigo-200 grid grid-cols-12 gap-x-4 items-center place-content-center",
      class: {
        'bg-indigo-200 border-l-2 border-indigo-600': _vm.itemDisplayed == index
      },
      attrs: {
        "id": 'intitule' + index
      },
      on: {
        "click": function ($event) {
          return _vm.displayItem(index);
        }
      }
    }, [_c('div', {
      staticClass: "col-span-2 text-pink-600 justify-self-center flex flex-col justify-around"
    }, [_c('icon', {
      staticClass: "transform transition-transform ease-in-out duration-300",
      class: {
        'rotate-90': _vm.itemDisplayed == index
      },
      attrs: {
        "name": "chevron-right"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-span-1"
    }), _vm._v(" "), _c('div', {
      staticClass: "col-span-9 text-base line-clamp-3"
    }, [_vm._v("\n              " + _vm._s(intitule.description) + "\n          ")])]), _vm._v(" "), _c('transition', {
      attrs: {
        "enter-active-class": "ease-out duration-300",
        "enter-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
        "enter-to-class": "opacity-100 translate-y-0 sm:scale-100",
        "leave-active-class": "ease-in duration-200",
        "leave-class": "opacity-100 translate-y-0 sm:scale-100",
        "leave-to-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.itemDisplayed === index,
        expression: "itemDisplayed === index"
      }],
      staticClass: "bg-white my-5 w-full relative flex flex-col space-y-4 px-5"
    }, [_c('TextToSpeech', {
      staticClass: "self-center",
      attrs: {
        "speak": intitule.description
      }
    }), _vm._v(" "), _c('input-text-area', {
      attrs: {
        "libelle": "Intitulé",
        "value": intitule.libelle,
        "disabled": true,
        "size": 3
      }
    }), _vm._v(" "), !_vm.autoHidden && !_vm.jauge ? _c('input-select', {
      attrs: {
        "name": index + 'auto_eval',
        "disabled": _vm.autoEvalDisabled,
        "datas": _vm.form.template[0].criterions,
        "value": _vm.form.items[index].autoEval,
        "libelle": "Auto-évaluation",
        "libelle-style": "text-base text-indigo-600",
        "libelle-icon": _vm.autoHidden ? 'eye-off' : 'eye'
      },
      on: {
        "input": function (newValue) {
          _vm.$set(_vm.form.items[index], 'autoEval', newValue);
        },
        "clickIcon": function ($event) {
          _vm.$can('compsocio_auto_eval_read', _vm.idPass) ? _vm.hide('autoEval') : null;
        }
      }
    }) : _vm._e(), _vm._v(" "), _vm.autoHidden && !_vm.jauge ? _c('input-select', {
      attrs: {
        "name": index + 'auto_eval',
        "datas": _vm.form.template[0].criterions,
        "value": '',
        "disabled": true,
        "libelle": "Auto-évaluation",
        "libelle-style": "text-base text-indigo-600",
        "libelle-icon": _vm.autoHidden ? 'eye-off' : 'eye'
      },
      on: {
        "clickIcon": function ($event) {
          _vm.$can('compsocio_auto_eval_read', _vm.idPass) ? _vm.hide('autoEval') : null;
        }
      }
    }) : _vm._e(), _vm._v(" "), !_vm.autoHidden && _vm.jauge ? _c('AnswerJauge', {
      attrs: {
        "libelle": "Auto-évaluation",
        "libelle-style": "text-base text-indigo-600",
        "libelle-icon": _vm.autoHidden ? 'eye-off' : 'eye',
        "disabled": false,
        "criteria": _vm.form.template[0].criterions,
        "reduced": false,
        "selected": _vm.form.items[index].autoEval
      },
      on: {
        "clickIcon": function ($event) {
          _vm.$can('compsocio_auto_eval_read', _vm.idPass) ? _vm.hide('autoEval') : null;
        },
        "select": function (answerIndex) {
          return _vm.select(index, 'autoEval', answerIndex, _vm.form.template[0].criterions);
        }
      }
    }) : _vm._e(), _vm._v(" "), _vm.autoHidden && _vm.jauge ? _c('AnswerJauge', {
      attrs: {
        "libelle": "Auto-évaluation",
        "libelle-style": "text-base text-indigo-600",
        "libelle-icon": _vm.autoHidden ? 'eye-off' : 'eye',
        "disabled": true,
        "criteria": _vm.form.template[0].criterions,
        "reduced": false
      },
      on: {
        "clickIcon": function ($event) {
          _vm.$can('compsocio_auto_eval_read', _vm.idPass) ? _vm.hide('autoEval') : null;
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('input-text', {
      class: {
        hidden: _vm.infosPass.id_pass == _vm.user.id
      },
      attrs: {
        "name": index + 'derniere_eval',
        "disabled": true,
        "value": _vm.lastValueMobile(intitule),
        "libelle": "Dernière évaluation du référent",
        "libelle-style": "text-base text-indigo-600",
        "libelle-icon": _vm.lastHidden ? 'eye-off' : 'eye'
      },
      on: {
        "clickIcon": function ($event) {
          return _vm.hide('lastEval');
        }
      }
    }), _vm._v(" "), _c('input-select', {
      class: {
        hidden: _vm.infosPass.id_pass == _vm.user.id
      },
      attrs: {
        "name": index + 'nouvelle_eval',
        "necessary": true,
        "datas": _vm.form.template[0].criterions,
        "value": _vm.form.items.filter(function (item) {
          return item.name && item.name === intitule.libelle || item.description === intitule.description;
        })[0].refEval,
        "disabled": _vm.infosPass.id_pass == _vm.user.id ? true : false,
        "libelle": "Nouvelle évaluation du référent",
        "libelle-style": "text-base text-indigo-600"
      },
      on: {
        "input": function (newValue) {
          _vm.$set(_vm.form.items[index], 'refEval', newValue);
        }
      }
    }), _vm._v(" "), _c('input-text-area', {
      class: {
        hidden: _vm.infosPass.id_pass == _vm.user.id
      },
      attrs: {
        "name": 'comment-' + index,
        "libelle": "Commentaire",
        "value": _vm.form.items.filter(function (item) {
          return item.name === intitule.libelle;
        })[0].comment,
        "size": 3
      },
      on: {
        "input": function (newValue) {
          _vm.$set(_vm.form.items[index], 'comment', newValue);
        }
      }
    })], 1)])], 1);
  }), 0), _vm._v(" "), _vm.form.template[2] && _vm.form.template[2].isDisplayed ? _c('input-text-area', {
    staticClass: "px-10 mt-10",
    class: {
      hidden: _vm.infosPass.id_pass == _vm.user.id
    },
    attrs: {
      "name": "comment",
      "libelle": "Commentaire général",
      "value": _vm.form.comment,
      "size": 3
    },
    on: {
      "input": function (newValue) {
        _vm.$set(_vm.form, 'comment', newValue);
      }
    }
  }) : _vm._e()], 1)], 1) : _c('div', [_c('h3', {
    staticClass: "my-15 w-full"
  }, [_vm._v("Accès restreint")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "text-gray-600 text-lg text-center"
  }, [_c('p', [_vm._v("\n        Veuillez ajouter un\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'PermissionsGuests'
      }
    }
  }, [_c('span', {
    staticClass: "cursor-pointer text-indigo-500 underline"
  }, [_vm._v("invité")])]), _vm._v("\n        pour accéder à cette évaluation.\n      ")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center w-full"
  }, [_c('illustration', {
    staticClass: "mt-15",
    attrs: {
      "name": "notAllowed"
    }
  })], 1)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }